import { render, staticRenderFns } from "./SignupView.vue?vue&type=template&id=298ea512&scoped=true"
import script from "./SignupView.vue?vue&type=script&lang=js"
export * from "./SignupView.vue?vue&type=script&lang=js"
import style0 from "./SignupView.vue?vue&type=style&index=0&id=298ea512&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298ea512",
  null
  
)

export default component.exports